<template>
  <div class="header-wrapper" :class="{ en: $i18n.locale === 'en-US' }">
    <div class="header-main pof" :class="{ scroll: isScroll }">
      <div class="content flex justify-between items-center">
        <div class="logo-wrapper flex justify-center items-center">
          <!-- logo -->
          <router-link
            :to="{
              path: '/',
            }"
          >
            <img class="logo" src="@/static/img/logo.png" />
          </router-link>
        </div>
        <ul class="menu-wrapper flex">
          <li class="menu-item empty"></li>
          <li
            class="menu-item"
            v-for="(item, index) in menuList"
            :key="index"
            :class="{
              active: isActiveMenu(item),
              por: item.type === 2,
            }"
          >
            <router-link
              v-if="item.path"
              :to="{
                path: item.path,
              }"
              class="menu-name"
            >
              <span class="menu-text">{{
                $t(`${i18nKey}.menu.${item.key}`)
              }}</span>
            </router-link>
            <div v-else class="menu-name">
              <span class="menu-text">{{
                $t(`${i18nKey}.menu.${item.key}`)
              }}</span>
            </div>
            <!-- 子面板 -->
            <template v-if="item.children?.length">
              <!-- 分类子菜单 -->
              <div
                :data-type="item.type"
                class="sub-menu poa flex justify-between"
                :class="{
                  hide: hideSubMenu,
                }"
              >
                <div
                  v-for="group in item.children"
                  :key="group.key"
                  class="flex-1 group"
                >
                  <div
                    v-if="group.key"
                    class="group-name text-bold flex column"
                  >
                    <p class="name-text flex-1 flex items-center">
                      {{ $t(`${i18nKey}.menu.${group.key}`) }}
                    </p>
                  </div>
                  <ul
                    v-if="group.children?.length"
                    class="group-submenu-list flex column"
                  >
                    <li
                      v-for="submenu in group.children"
                      :key="submenu.key"
                      class="group-submenu-item flex"
                      :class="{
                        active: isActiveMenu(submenu),
                      }"
                    >
                      <router-link
                        v-if="submenu.path"
                        :to="{
                          path: submenu.path,
                        }"
                        class="flex items-center"
                      >
                        <img
                          v-if="submenu.icon"
                          class="menu-icon"
                          :src="submenu.icon"
                        />
                        <p class="group-submenu-name" v-html="$t(`${i18nKey}.menu.${submenu.key}`)">
                          <!-- {{ $t(`${i18nKey}.menu.${submenu.key}`) }} -->
                        </p>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </li>
          <li class="menu-item" @click="toggleLang">
            <p class="menu-name" v-if="$i18n.locale === 'en-US'">
              <span style="color: #6f7175">CN / </span><span>EN</span>
            </p>
            <p class="menu-name" v-else>
              <span>CN</span><span style="color: #6f7175"> / EN</span>
            </p>
          </li>
          <li class="menu-item contact" @click="dialogVisible = true">
            <div class="menu-name">
              {{ $t(`${i18nKey}.menu.contact`) }}
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 合作咨询 -->
    <el-dialog
      id="systemConfiguration"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="close"
      center
    >
      <span slot="title">
        <div id="text">
          <div id="text1">{{ $t(`${i18nKey}.dialog.title`) }}</div>
          <div
            id="text2"
            class="pre-wrap"
            v-text="$t(`${i18nKey}.dialog.content`)"
          />
        </div>
      </span>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="auto"
        :label-position="labelPosition"
      >
        <el-form-item :label="$t(`${i18nKey}.dialog.form.name`)" prop="name">
          <template slot="label">
            <span>{{ $t(`${i18nKey}.dialog.form.name`) }}</span>
            <span class="required-field">*</span>
          </template>
          <el-input
            v-model="ruleForm.name"
            autocomplete="off"
            :placeholder="$t(`${i18nKey}.dialog.form.namePlaceholder`)"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t(`${i18nKey}.dialog.form.phone`)" prop="tel">
          <template slot="label">
            <span>{{ $t(`${i18nKey}.dialog.form.phone`) }}</span>
            <span class="required-field">*</span>
          </template>
          <el-input
            v-model="ruleForm.tel"
            autocomplete="off"
            :placeholder="$t(`${i18nKey}.dialog.form.phonePlaceholder`)"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t(`${i18nKey}.dialog.form.email`)" prop="mail">
          <template slot="label">
            <span>{{ $t(`${i18nKey}.dialog.form.email`) }}</span>
            <span class="required-field">*</span>
          </template>
          <el-input
            v-model="ruleForm.mail"
            autocomplete="off"
            :placeholder="$t(`${i18nKey}.dialog.form.emailPlaceholder`)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t(`${i18nKey}.dialog.form.company`)"
          prop="company"
        >
          <template slot="label">
            <span>{{ $t(`${i18nKey}.dialog.form.company`) }}</span>
            <span class="required-field">*</span>
          </template>
          <el-input
            v-model="ruleForm.company"
            autocomplete="off"
            :placeholder="$t(`${i18nKey}.dialog.form.companyPlaceholder`)"
          >
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="您的需求" prop="demand">
          <el-input
            type="textarea"
            v-model="ruleForm.demand"
            autocomplete="off"
            placeholder="请写下您的需求，以便我们更好匹配相关人员联系您"
          >
          </el-input>
          <textarea
            placeholder="请写下您的需求，以便我们更好匹配相关人员联系您"
          ></textarea>
        </el-form-item> -->
      </el-form>
      <div class="careContent">
        <div class="h1">{{ $t(`${i18nKey}.dialog.care`) }}</div>
        <div class="ul">
          <div
            class="li"
            :class="{ active: item.active }"
            v-for="(item, index) in list"
            :key="index"
            @click="liClickEvent(item, index)"
          >
            <!-- {{ item.text }} -->
            {{ $t(`${i18nKey}.dialog.careTags[${index}]`) }}
            <div class="ipt" v-if="item.isShowIpt">
              <label
                class="other"
                :class="{ label: isShowOther, otherBg: otherBg }"
                @click="otherEvent"
                >{{ $t(`${i18nKey}.dialog.other`) }}</label
              >
              <input
                v-if="isShowOther"
                :placeholder="$t(`${i18nKey}.dialog.otherPlaceholder`)"
                v-model="item.inputVal"
                @input="inputEvent(item.inputVal)"
              />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" id="dialog-footer">
        <el-button @click="submitForm('ruleForm')">{{
          $t(`${i18nKey}.dialog.submit`)
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 合作咨询 -->

    <MessageTip ref="MessageTip" />
  </div>
</template>

<script>
import { commit } from "@/api";
import { Message } from "element-ui";
import MessageTip from "./MessageTip.vue";
import DiLIcon from "@/static/img/navbar/DiL.svg";
import GaiAIcon from "@/static/img/navbar/GaiA.svg";
import HerculesIcon from "@/static/img/navbar/Hercules.svg";
import MedusaIcon from "@/static/img/navbar/Medusa.svg";
import OnCloudIcon from "@/static/img/navbar/OnCloud.svg";
import PlenRayIcon from "@/static/img/navbar/PlenRay.svg";
import RHeaIcon from "@/static/img/navbar/RHea.svg";
import RobotIcon from "@/static/img/navbar/Robot.svg";
import UranusIcon from "@/static/img/navbar/Uranus.svg";

export default {
  components: {
    MessageTip,
    Message,
    "el-message": Message,
  },

  data() {
    const formPrefix = "header.dialog.form";
    /**
     *合作咨询
     */
    //自定义密码表单验证规则
    const checkNamePass = (rule, value, callback) => {
      // name正则表达式验证
      // const regPass =
      //   /^(?:[\u4e00-\u9fa5·]{2,16})$/ ||
      //   /(^[a-zA-Z][a-zA-Z\s]{0,20}[a-zA-Z]$)/;
      if (value === "") {
        // callback(new Error("姓名不能为空!"));
        callback(new Error(this.$t(`${formPrefix}.nameIsRequired`)));
      }
      // else if (!regPass.test(value)) {
      //   callback(new Error("姓名只能为2-16位数字组成!"));
      // }
      return callback();
    };
    const checkTelPass = (rule, value, callback) => {
      // Tel正则表达式验证
      // const regPass =
      //   /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/;
      // if (value === "") {
      //   callback(new Error("手机号码不能为空!"));
      // } else if (!regPass.test(value)) {
      //   callback(new Error("请输入正确的手机号码"));
      // }

      if (value === "") {
        // callback(new Error("手机号码不能为空!"));
        callback(new Error(this.$t(`${formPrefix}.phoneIsRequired`)));
      }
      return callback();
    };
    const checkMailPass = (rule, value, callback) => {
      // company正则表达式验证
      const regPass =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (value === "") {
        // callback(new Error("邮箱不能为空!"));
        callback(new Error(this.$t(`${formPrefix}.emailIsRequired`)));
      } else if (!regPass.test(value)) {
        // callback(new Error("请输入合法的邮箱"));
        callback(new Error(this.$t(`${formPrefix}.emailFormatError`)));
      }
      return callback();
    };
    const checkCompanyPass = (rule, value, callback) => {
      // company正则表达式验证
      // const regPass =
      //   /^(?:[\u4e00-\u9fa5·]{2,16})$/ ||
      //   /(^[a-zA-Z][a-zA-Z\s]{0,20}[a-zA-Z]$)/;
      if (value === "") {
        // callback(new Error("公司名称不能为空!"));
        callback(new Error(this.$t(`${formPrefix}.companyIsRequired`)));
      }
      //  else if (!regPass.test(value)) {
      //   callback(new Error("请输入合法的公司名称"));
      // }
      return callback();
    };
    /**
     *合作咨询
     */
    return {
      i18nKey: "header",
      /**
       *顶部滚动
       */
      isScroll: false,

      // 菜单
      menuList: [
        {
          key: "home",
          path: "/",
        },
        {
          key: "product",
          type: 1,
          children: [
            {
              key: "allIntelligence",
              children: [
                {
                  key: "PDGaiA",
                  path: "/productGaiA",
                  icon: GaiAIcon,
                },
                {
                  key: "PDRobot",
                  path: "/productRobot",
                  icon: RobotIcon,
                },
                {
                  key: "PDUranus",
                  path: "/productUranus",
                  icon: UranusIcon,
                },
              ],
            },
            {
              key: "coreTechnology",
              children: [
                {
                  key: "OnCloud",
                  path: "/productClound",
                  icon: OnCloudIcon,
                },
                {
                  key: "PDRHea",
                  path: "/productRHea",
                  icon: RHeaIcon,
                },
                {
                  key: "PlenRay",
                  path: "/coretechnology",
                  icon: PlenRayIcon,
                },
              ],
            },
            {
              key: "softwareAndHardware",
              children: [
                {
                  key: "DiL",
                  path: "/productRing",
                  icon: DiLIcon,
                },
                {
                  key: "Medusa",
                  path: "/productMedusa",
                  icon: MedusaIcon,
                },
                {
                  key: "Hercules",
                  path: "/productHercules",
                  icon: HerculesIcon,
                },
              ],
            },
          ],
        },
        {
          key: "ecosystem",
          type: 2,
          children: [
            {
              key: "",
              children: [
                {
                  key: "matrix",
                  path: "/modelSharePlatform",
                },
                {
                  key: "cooperation",
                  path: "/ecologicalCooperationSharePlatform",
                },
                {
                  key: "fullscale",
                  path: "/FullScaleAutonomousDriving",
                },
              ],
            },
          ],
        },
        {
          key: "about",
          path: "/aboutUs",
        },
        {
          key: "join",
          path: "/joinUs",
        },
      ],

      // 跳转之后需要隐藏二级菜单
      hideSubMenu: false,

      /**
       *合作咨询
       */
      labelPosition: "right",
      visible: false,
      message: "",
      duration: 3000,
      //合作咨询
      dialogVisible: false,
      ruleForm: {
        name: "",
        tel: "",
        company: "",
        mail: "",
        // demand: "",
      },
      rules: {
        name: [{ validator: checkNamePass, trigger: "blur" }],
        tel: [{ validator: checkTelPass, trigger: "blur" }],
        mail: [{ validator: checkMailPass, trigger: "blur" }],
        company: [{ validator: checkCompanyPass, trigger: "blur" }],
      },
      list: [
        {
          text: "SiL仿真平台",
          active: true,
        },
        {
          text: "HiL仿真平台",
          active: false,
        },
        {
          text: "DiL仿真平台",
          active: false,
        },
        {
          text: "交通流仿真",
          active: false,
        },
        {
          text: "物理级传感器",
          active: false,
        },
        {
          text: "场景还原",
          active: false,
        },
        {
          text: "自动化场景搭建",
          active: false,
        },
        {
          isShowIpt: true,
          inputVal: "",
        },
      ],
      isShowOther: false,
      otherBg: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    // 监听语言切换
    "$route.path": function (newVal) {
      this.hideSubMenu = true; // 路由变化时隐藏子菜单
      setTimeout(() => {
        this.hideSubMenu = false; // 延时后恢复子菜单显示
      }, 300); // 300毫秒延时，确保路由切换完成
    },
  },
  methods: {
    /**
     *判断当前菜单是否激活
     */
    isActiveMenu(item) {
      const currentPath = this.$route.path;
      if (item.path) {
        return currentPath === item.path;
      } else if (item.children) {
        return item.children.some((child) => this.isActiveMenu(child));
      }
      return false;
    },
    /**
     *合作咨询
     */
    liClickEvent(item, index) {
      item.active = !item.active;
    },
    otherEvent() {
      this.isShowOther = !this.isShowOther;
      this.otherBg = false;
      if (this.isShowOther) {
        this.list[this.list.length - 1].inputVal = "";
      }
    },
    inputEvent(val) {
      if (val.length !== 0) {
        this.otherBg = true;
      } else {
        this.otherBg = false;
      }
    },

    /**
     *中英文切换
     */
    toggleLang() {
      this.$i18n.locale = this.$i18n.locale === "zh-CN" ? "en-US" : "zh-CN";
      localStorage.setItem("lang", this.$i18n.locale); // 可选项，将语言保存到本地存储中
    },

    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
    submitForm(ruleForm) {
      let VALUE = {};
      VALUE.name = this.ruleForm.name;
      VALUE.company = this.ruleForm.company;
      VALUE.tel = this.ruleForm.tel;
      VALUE.mail = this.ruleForm.mail;
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let focusArr = [];
          this.list.forEach((item) => {
            if (item.active && !item.isShowIpt) {
              focusArr.push(item.text);
            }
            if (item.isShowIpt && item.inputVal !== "") {
              VALUE["msg"] = item.inputVal;
            }
          });
          VALUE["focus"] = focusArr.join(",");
          try {
            commit(VALUE)
              .then((res) => {
                if (res.data.code === 200) {
                  this.ruleForm.name = "";
                  this.ruleForm.tel = "";
                  this.ruleForm.mail = "";
                  this.ruleForm.company = "";
                  this.dialogVisible = false;
                  this.$refs.MessageTip.message();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          return false;
        }
      });
      // 进行接口的操作之后进行数据的清空
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      //清除全部提示信息
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
      // this.$refs.ruleForm.clearValidate('name');
      // 其中，fieldName 是您要清除提示信息的字段名称。希望这可以帮助您解决问题！
      // 清空您关注的内容 部分
      this.list.forEach((item, index) => {
        if (item.active && !item.isShowIpt && index !== 0) {
          item.active = false;
        } else if (item.isShowIpt) {
          item.inputVal = "";
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header-wrapper {
  .header-main {
    top: 1.4rem;
    left: 0;
    width: 100%;
    height: 3rem;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0);
    transition: all 0.3s ease-in-out;
    padding: 0 1.5rem;
    .content {
      width: 100%;
      height: 100%;
      border-radius: 0.25rem;
      backdrop-filter: blur(0.187rem);
      .logo-wrapper {
        width: 12.4rem;
        height: 100%;
        .logo {
          width: 8.4rem;
          height: 3rem;
          vertical-align: middle;
        }
      }
      .menu-wrapper {
        height: 100%;
        .menu-item {
          color: white;
          width: 5.6rem;
          height: 100%;
          border: 1px solid rgba(255, 255, 255, 0.16);
          border-right: none;
          font-size: 0.875rem;
          &:not(.empty) {
            cursor: pointer;
          }
          .menu-name {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .sub-menu {
            display: none;
            width: 100%;
            left: 0;
            top: 100%;
            padding: 1.5rem 5.86rem;
            .group {
              width: 0;
              min-width: 25.3rem;
              .group-name {
                font-size: 1rem;
                min-height: 3rem;
                padding: 0 2rem;
                .name-text {
                  border-bottom: 1px solid #363641;
                  padding: 0.75rem 0;
                }
              }
              .group-submenu-list {
                padding-top: 1rem;
                gap: 0.5rem;
              }
              .group-submenu-item {
                a {
                  min-height: 2.5rem;
                  align-items: center;
                  padding: 0 2rem;
                  width: 100%;
                  height: 100%;
                }
                &.active {
                  color: #d71f28;
                }
                &:hover {
                  background-color: #1d202b;
                }
              }
              .group-submenu-name {
                padding: 0.47rem 0;
              }
              .menu-icon {
                width: 2.5rem;
                height: 2.5rem;
                margin-right: 0.63rem;
              }
            }
            &[data-type="2"] {
              padding: 0;
              width: auto;
              .group {
                width: auto;
                min-width: auto;
                white-space: nowrap;
                .group-submenu-list {
                  padding-top: 0;
                  gap: 0;
                }
              }
            }
          }
          a {
            text-decoration: none;
            color: inherit;
          }
          &:hover:not(:first-child) {
            background-color: #070a16;
            .sub-menu:not(.hide) {
              display: flex;
              background-color: #070a16;
            }
          }
          &.empty {
            border: none;
          }
          &.contact {
            width: 10rem;
            background-color: #d71f28;
            border: none;
            border-radius: 0.25rem;
          }
          &.active {
            .menu-name {
              color: #d71f28;
            }
          }
        }
      }
    }
    &.scroll {
      top: 0;
      background-color: #070a16;
      .content {
        .menu-wrapper {
          .menu-item {
            border: none;
          }
          .sub-menu {
            width: 100vw;
            left: -1.5rem;
          }
        }
      }
    }
  }

  .el-message.my-message {
    background-color: #333;
    color: #fff;
  }

  //对话框
  ::v-deep .el-dialog {
    // width: 55%;
    width: 5800px;
    border-radius: 0.5rem;
    mix-blend-mode: normal;
    box-shadow: 0px 0.9375rem 1.5rem rgba(0, 0, 0, 0.25);
    background: linear-gradient(0.98deg, #0b1125 0.9%, #171e37 99.24%);
    position: relative;
    margin: auto !important;
  }

  #systemConfiguration {
    // width: 65rem;
    display: flex;
    // justify-content: center;
    // align-items: center;
    // margin: auto;
    // overflow: hidden;

    .required-field {
      display: inline-block;
      color: #d22a30;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.375rem;
      margin-left: 0.3rem;
    }

    //头部
    #text {
      width: 80%;
      margin: auto;
      display: flex;
      padding-top: 2rem;
      box-sizing: border-box;
      flex-direction: column;
      /* background-color: red; */

      #text1 {
        /* background-color: green; */
        /* width: 18rem; */
        font-size: 1.6rem;
        font-weight: 400;
        text-align: left;
        font-style: normal;
        padding-top: 0.5rem;
        line-height: 2.2rem;
        box-sizing: border-box;
        padding-bottom: 0.5rem;
        color: rgba(255, 255, 255, 0.85);
      }

      #text2 {
        /* background-color: yellow; */
        font-style: normal;
        text-align: left;
        color: #ffffff73;
        font-weight: 400;
        line-height: 1.25rem;
        // font-size: 0.4rem;
        font-size: 0.75rem;
        padding-top: 0.5rem;
        box-sizing: border-box;
      }
    }

    //头部
    ::v-deep .el-dialog__header {
      // padding-bottom: 2rem;
      /* background-color: green; */
      padding-bottom: 2rem;

      .el-dialog__headerbtn .el-dialog__close:hover {
        color: #d71f28;
      }
    }

    //中间
    ::v-deep .el-dialog--center .el-dialog__body {
      text-align: initial;
      padding: 25px 25px 0px;
      /* background-color: rgba(24, 212, 245, 0.473); */
    }

    ::v-deep .el-form {
      /* background-color: green; */
      // padding-bottom: 1rem;
      box-sizing: border-box;
      color: rgba(255, 255, 255, 0.85);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .el-form-item__error {
        color: rgba(215, 31, 40, 1);
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
      }

      .el-form-item__label {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.85);
        line-height: 2.2rem;
        /* background-color: yellow; */
      }

      // 缩放时可能错位，所以添加这一行--没法修
      // .el-form-item__label-wrap {
      //   margin-right: -0.125rem;
      // }

      .el-form-item {
        width: 75%;
      }

      .el-form-item:last-child {
        color: rgba(255, 255, 255, 0.85);
        line-height: 2.2rem;

        .el-form-item__label {
          color: rgba(255, 255, 255, 0.85);
          line-height: 2.2rem;
          /* background-color: yellow; */
          align-self: flex-start;
        }

        .el-textarea {
          width: 108%;
          padding-top: 0.2rem;
          overflow: hidden;
          border-radius: 0.25rem !important;
          border-top-right-radius: 0.45rem !important;
        }

        .el-textarea__inner {
          width: 108%;
          resize: none;
          font-size: 1rem;
          background-color: #22273f;
          height: 3.375rem !important;
          border: 1px solid #22273f;
          //修改光标的颜色
          caret-color: rgba(255, 255, 255, 0.85);
          color: rgba(255, 255, 255, 0.85);
        }

        textarea::placeholder {
          padding-top: 0.2rem;
          font-size: 1rem;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.25);
        }
      }

      .el-input__inner {
        height: 2rem;
        border-radius: 0.25rem;
        background-color: #22273f;
        color: rgba(255, 255, 255, 0.85);
        //修改光标的颜色
        caret-color: rgba(255, 255, 255, 0.85);
        border: 0px solid rgba(255, 255, 255, 0.25);
      }

      ::-webkit-input-placeholder {
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.25);
        font-style: normal;
        font-weight: 400;
        line-height: 1.375rem;
      }

      :-moz-placeholder {
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.25);
        font-style: normal;
        font-weight: 400;
        line-height: 1.375rem;
      }

      ::moz-placeholder {
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.25);
        font-style: normal;
        font-weight: 400;
        line-height: 1.375rem;
      }

      :-ms-input-placeholder {
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.25);
        font-style: normal;
        font-weight: 400;
        line-height: 1.375rem;
      }
    }

    //底部
    ::v-deep .el-dialog .el-dialog__footer {
      height: 6.8rem;
      /* background-color: red; */
    }

    #dialog-footer {
      ::v-deep .myMessage {
        background-color: #ff4c4c !important;
        color: #fff !important;
        z-index: 999;
      }

      .el-button {
        margin-bottom: 5rem;
        margin-top: 1.5rem;
        font-size: 1rem;
        border: 0px solid red;
        color: rgba(255, 255, 255, 1);
        background-color: rgba(215, 31, 40, 1);
        font-weight: 400;
      }
    }

    .careContent {
      width: 75%;
      margin: 0 auto;

      .h1 {
        color: rgba(255, 255, 255, 0.85);
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.375rem;
        margin-bottom: 1rem;
      }

      .ul {
        width: 29.625rem;
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
        gap: 1rem;

        .li {
          // height: 1.5rem;
          padding: 0.3125rem 0.8rem;
          border-radius: 0.25rem;
          background: rgba(34, 39, 63, 0.75);
          color: rgba(255, 255, 255, 0.65);
          text-align: center;
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 1.5rem;
          text-transform: capitalize;
          cursor: pointer;

          &:last-child {
            width: 60%;
            padding: 0;
            text-align: center;
            background-color: transparent;
          }

          .ipt {
            height: 2rem;
            background: #22273f;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            // width: 100%;
            border-radius: 0.25rem;

            .other {
              color: rgba(255, 255, 255, 0.65);
            }

            .label {
              color: rgba(255, 255, 255, 0.65);
              // color: #FFF;
              width: 3rem;
              height: 1.9rem;
              line-height: 1.9rem;
              border-radius: 0.25rem 0 0 0.25rem;
              // border-right: 1px solid #0c1227;
              // background-color: rgba(215, 31, 40, 1);
            }

            .otherBg {
              color: #fff;
              background-color: rgba(215, 31, 40, 1);
            }

            input {
              width: 80%;
              height: 0.9rem;
              padding: 0.5rem 0.75rem;
              border-radius: 0 0.25rem 0.25rem 0;
              background: rgba(34, 39, 63, 0.75);
              color: #fff;
              border: 0;

              &:focus-visible {
                outline: none;
              }
            }

            ::-webkit-input-placeholder {
              font-size: 0.75rem;
              color: rgba(255, 255, 255, 0.25);
              font-style: normal;
              font-weight: 400;
              line-height: 1.375rem;
            }

            :-moz-placeholder {
              font-size: 0.75rem;
              color: rgba(255, 255, 255, 0.25);
              font-style: normal;
              font-weight: 400;
              line-height: 1.375rem;
            }

            ::moz-placeholder {
              font-size: 0.75rem;
              color: rgba(255, 255, 255, 0.25);
              font-style: normal;
              font-weight: 400;
              line-height: 1.375rem;
            }

            :-ms-input-placeholder {
              font-size: 0.75rem;
              color: rgba(255, 255, 255, 0.25);
              font-style: normal;
              font-weight: 400;
              line-height: 1.375rem;
            }
          }
        }

        .ipt {
          width: fit-content;
          min-width: 4.125rem;
          border: 0;

          &::placeholder {
            color: rgba(255, 255, 255, 0.65);
          }
        }

        .active {
          color: #fff;
          background-color: #d71f28;
        }
      }
    }
  }

  &.en {
    .header-main {
      .content {
        .menu-wrapper {
          .menu-item {
            .sub-menu {
              .group {
                .group-name {
                  // min-height: 900px;
                  font-size: 0.875rem;
                }
              }
              &[data-type="2"] {
                .group {
                  // min-width: 31.8rem;
                  min-width: 29rem;
                  white-space: initial;
                }
              }
            }
          }
        }
      }
    }
    #systemConfiguration {
      #text2 {
        line-height: 1.5 !important;
        // text-align: justify !important;
      }
      .careContent .ul .li .ipt input {
        width: 64%;
      }
      ::v-deep .el-form {
        // 缩放时可能错位，所以添加这一行
        // .el-form-item__label-wrap {
        //   margin-right: -0.25rem;
        // }
      }
    }
  }
}
</style>
